import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from '../config/axios';


const initialState = {
    data: null,
    isLoading: false,
    error: null
};




export const scrappedData = createAsyncThunk("scrappedData", async ({ args }, { rejectWithValue }) => {
    console.log(args, 'juhuhuhu');
    try {
        const { data } = await axios.post('https://dev.zyratalk.com/newengage/public/api/scrappedData', args, {
            timeout: 10000,
            // headers: {
            //     'Content-Type': 'application/json',

            // }
        });
        console.log(data, 'datadatadata')

        return data;
    } catch (error) {
        rejectWithValue(error);
    }
})


export const scrappedDataSlice = createSlice({
    name: 'scrappedData',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(scrappedData.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(scrappedData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
            })
            .addCase(scrappedData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    }
});

export default scrappedDataSlice.reducer;

